import { render, staticRenderFns } from "./SubMainMenu.vue?vue&type=template&id=717b5b5d&scoped=true&"
import script from "./SubMainMenu.vue?vue&type=script&lang=js&"
export * from "./SubMainMenu.vue?vue&type=script&lang=js&"
import style0 from "./SubMainMenu.vue?vue&type=style&index=0&id=717b5b5d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717b5b5d",
  null
  
)

export default component.exports